import base from '../dr-base'
import drDateEdit from './dr-date-edit.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-date-edit',
  name: 'Date edit',
  group: 'Input widgets',
  icon: 'calendar-day',
  ...base,
  properties: {
    ...base.properties,
    Time: {
      name: 'vuetifyWidgets.dr-date-edit.time',
      type: 'boolean',
      default: false
    },
    MinDate: {
      name: 'minDate',
      type: 'string',
      HintText: 'vuetifyWidgets.dr-date-edit.format',
      default: ''
    },
    MaxDate: {
      name: 'maxDate',
      type: 'string',
      HintText: 'vuetifyWidgets.dr-date-edit.format',
      default: ''
    },
    Disabled: {
      name: 'vuetifyWidgets.dr-date-edit.disabled',
      type: 'string',
      default: ''
    },
    Value: {
      type: 'string',
      name: 'vuetifyWidgets.dr-date-edit.value',
      component: 'dr-value-editor'
    },
    Caption: {
      type: 'string',
      name: 'vuetifyWidgets.dr-date-edit.caption'
    },
    Mode: {
      name: 'vuetifyWidgets.dr-date-edit.mode',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'date',
        text: 'vuetifyWidgets.dr-date-edit.date'
      }, {
        value: 'month',
        text: 'vuetifyWidgets.dr-date-edit.month'
      }]
    },
    Style: {
      name: 'vuetifyWidgets.dr-date-edit.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-date-edit.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drDateEdit,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
